import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgDataListComponent, ExgModalService} from 'exc-controls-v2';
import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
  transferArrayItem
} from '@angular/cdk/drag-drop';
import {ExcRestService} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../../../../services/enumeration.service';

@Component({
  selector: 'app-modal-pick-page-of-pdf',
  templateUrl: './modal-pick-page-of-pdf.component.html',
  styles: [
  ]
})
export class ModalPickPageOfPDFComponent extends ExcTranslation implements OnInit {
  @Input() data: any;
  @ViewChild('AttachementList', {read: ExgDataListComponent}) AttList!: ExgDataListComponent;
  page = {};
  allPagesRightSide: any[] = [];
  editAreaMiddle: any[] = [];
  selectedPagesLeftSide: any[] = [];
  inputWasEmpty = true;

  constructor(
    public excRest: ExcRestService,
    public modal: ExgModalService,
    public excSecurity: ExcSecurityService,
    public enumSvc: EnumerationService,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.data.page && this.data.page !== {}){
      for (let i = 0; i < this.data.page.dokPages; i++) {
        const singlePage = {...this.data.page, selectedPage: i + 1};
        this.allPagesRightSide.splice(i, 0, singlePage);
      }
    }
    else {
      this.cancel();
    }
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modal.close();
  }

  save(): void {
    if (this.selectedPagesLeftSide?.length > 0) {
      this.modal.action({selectedPages: this.selectedPagesLeftSide});
    }
    else {
      this.modal.action({selectedPage: ''});
    }
  }

  selectAllPages(): void {
    this.selectedPagesLeftSide.push(
      ...this.allPagesRightSide.splice(0)
    );

    this.selectedPagesLeftSide.sort(
      (a: any, b: any) =>
        Number(a.selectedPage) -
        Number(b.selectedPage)
    );
  }

  deselectAllPages(): void {
    this.allPagesRightSide.push(
      ...this.selectedPagesLeftSide.splice(0)
    );

    this.allPagesRightSide.sort(
      (a: any, b: any) =>
        Number(a.selectedPage) -
        Number(b.selectedPage)
    );
  }

  drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
  }


  isPicDropAvailable(drag: CdkDrag, dropList: CdkDropList): boolean {
    return true; // Hier kannst du deine Logik zur Überprüfung hinzufügen
  }
}
